import * as React from 'react';
import styled from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import HybridLink from '../Generic/Links/HybridLink';
import useTranslator from 'Client/hooks/useTranslator';
import useConfig from 'Client/hooks/useConfig';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import useGa from 'Client/hooks/useGa';
import { BellaTestIds } from 'Common/qaIds';
import { useCurrentPageType } from 'Client/hooks/UrlManager/pageTypeHooks';
import paths from 'Common/routes/paths';
import { ensureEndingSlash } from 'Client/urlService';

const StyledFooterLink = styled(HybridLink)`
    color: ${({ theme }) => theme.colors.charcoal100};
    display: block;
    text-decoration: none;
    line-height: 21px;
    padding-bottom: 9px;
    ${forDesktop`
        padding: 4.5px 0;
    `}
`;
const StyledWrapper = styled.div`
    padding: 20px 0 25px;
    ${forDesktop`
        padding: 20px 0 30px;
    `}
`;

const useUsefulInformationLinks = () => {
    const gaTracking = useGa();
    const { pageType } = useCurrentPageType();

    const trackInteriorDesignService = () => {
        gaTracking.trackGenericEvent('Footer', {
            action: 'Beratung - click',
            label: pageType,
        });
    };

    return { trackInteriorDesignService };
};

export const UsefulInformation = () => {
    const { links } = useConfig();
    const t = useTranslator();
    const featureToggles = useFeatureToggle();
    const { trackInteriorDesignService } = useUsefulInformationLinks();

    const footerItems = [
        { link: links.press, tKey: 'Footer_Press' },
        { link: links.imprint, tKey: 'Footer_Imprint' },
        { link: links.brands, tKey: 'Footer_Brands' },
        { link: links.agb, tKey: 'Footer_AGB' },
        {
            link: ensureEndingSlash(paths.INTERIOR_DESIGN_SERVICE),
            tKey: 'Footer_Interior_service',
            onClick: trackInteriorDesignService,
        },
        { link: links.career, tKey: 'Footer_Career' },
        { link: links.dataProtection, tKey: 'Footer_Data_protection' },
        { link: links.styleHub, tKey: 'Footer_Style_Hub' },
    ];

    return (
        <StyledWrapper>
            {footerItems.map(({ link, tKey, onClick }) => {
                if (!link || (link.startsWith(paths.INTERIOR_DESIGN_SERVICE) && !featureToggles.interiorServiceInNav)) {
                    return null;
                }

                return (
                    <StyledFooterLink data-testid={BellaTestIds.footerLinks} key={link} to={link} onClick={onClick}>
                        {t(tKey)}
                    </StyledFooterLink>
                );
            })}
        </StyledWrapper>
    );
};

export default React.memo(UsefulInformation);
